/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export type co_getplato_grid_httphandlers_Capabilities = {
    find_sales_order: co_getplato_grid_httphandlers_Capabilities.find_sales_order;
    mark_quote_as_won_or_lost: co_getplato_grid_httphandlers_Capabilities.mark_quote_as_won_or_lost;
    release_sales_order: co_getplato_grid_httphandlers_Capabilities.release_sales_order;
    delete_sales_order: co_getplato_grid_httphandlers_Capabilities.delete_sales_order;
    get_sales_order_pdf: co_getplato_grid_httphandlers_Capabilities.get_sales_order_pdf;
    send_sales_order_pdf: co_getplato_grid_httphandlers_Capabilities.send_sales_order_pdf;
    find_product_variant_price: co_getplato_grid_httphandlers_Capabilities.find_product_variant_price;
    find_product_variant_price_gross_margin: co_getplato_grid_httphandlers_Capabilities.find_product_variant_price_gross_margin;
    find_product_variant_price_rebates: co_getplato_grid_httphandlers_Capabilities.find_product_variant_price_rebates;
    find_product_variant_stock: co_getplato_grid_httphandlers_Capabilities.find_product_variant_stock;
    find_sales_order_header_default_values: co_getplato_grid_httphandlers_Capabilities.find_sales_order_header_default_values;
    submit_draft_order: co_getplato_grid_httphandlers_Capabilities.submit_draft_order;
    submit_draft_order_po_number: co_getplato_grid_httphandlers_Capabilities.submit_draft_order_po_number;
    submit_draft_order_note: co_getplato_grid_httphandlers_Capabilities.submit_draft_order_note;
    get_customer_credit_limit: co_getplato_grid_httphandlers_Capabilities.get_customer_credit_limit;
    get_customer_address: co_getplato_grid_httphandlers_Capabilities.get_customer_address;
    create_update_delete_customer_address: co_getplato_grid_httphandlers_Capabilities.create_update_delete_customer_address;
    get_customer_contacts: co_getplato_grid_httphandlers_Capabilities.get_customer_contacts;
    create_update_delete_customer_contacts: co_getplato_grid_httphandlers_Capabilities.create_update_delete_customer_contacts;
    create_customer_contact: co_getplato_grid_httphandlers_Capabilities.create_customer_contact;
    find_available_sales_documents: co_getplato_grid_httphandlers_Capabilities.find_available_sales_documents;
    find_sales_document: co_getplato_grid_httphandlers_Capabilities.find_sales_document;
};
export namespace co_getplato_grid_httphandlers_Capabilities {
    export enum find_sales_order {
        READY = 'READY',
        NOT_READY = 'NOT_READY',
        NOT_SUPPORTED = 'NOT_SUPPORTED',
    }
    export enum mark_quote_as_won_or_lost {
        READY = 'READY',
        NOT_READY = 'NOT_READY',
        NOT_SUPPORTED = 'NOT_SUPPORTED',
    }
    export enum release_sales_order {
        READY = 'READY',
        NOT_READY = 'NOT_READY',
        NOT_SUPPORTED = 'NOT_SUPPORTED',
    }
    export enum delete_sales_order {
        READY = 'READY',
        NOT_READY = 'NOT_READY',
        NOT_SUPPORTED = 'NOT_SUPPORTED',
    }
    export enum get_sales_order_pdf {
        READY = 'READY',
        NOT_READY = 'NOT_READY',
        NOT_SUPPORTED = 'NOT_SUPPORTED',
    }
    export enum send_sales_order_pdf {
        READY = 'READY',
        NOT_READY = 'NOT_READY',
        NOT_SUPPORTED = 'NOT_SUPPORTED',
    }
    export enum find_product_variant_price {
        READY = 'READY',
        NOT_READY = 'NOT_READY',
        NOT_SUPPORTED = 'NOT_SUPPORTED',
    }
    export enum find_product_variant_price_gross_margin {
        READY = 'READY',
        NOT_READY = 'NOT_READY',
        NOT_SUPPORTED = 'NOT_SUPPORTED',
    }
    export enum find_product_variant_price_rebates {
        READY = 'READY',
        NOT_READY = 'NOT_READY',
        NOT_SUPPORTED = 'NOT_SUPPORTED',
    }
    export enum find_product_variant_stock {
        READY = 'READY',
        NOT_READY = 'NOT_READY',
        NOT_SUPPORTED = 'NOT_SUPPORTED',
    }
    export enum find_sales_order_header_default_values {
        READY = 'READY',
        NOT_READY = 'NOT_READY',
        NOT_SUPPORTED = 'NOT_SUPPORTED',
    }
    export enum submit_draft_order {
        READY = 'READY',
        NOT_READY = 'NOT_READY',
        NOT_SUPPORTED = 'NOT_SUPPORTED',
    }
    export enum submit_draft_order_po_number {
        READY = 'READY',
        NOT_READY = 'NOT_READY',
        NOT_SUPPORTED = 'NOT_SUPPORTED',
    }
    export enum submit_draft_order_note {
        READY = 'READY',
        NOT_READY = 'NOT_READY',
        NOT_SUPPORTED = 'NOT_SUPPORTED',
    }
    export enum get_customer_credit_limit {
        READY = 'READY',
        NOT_READY = 'NOT_READY',
        NOT_SUPPORTED = 'NOT_SUPPORTED',
    }
    export enum get_customer_address {
        READY = 'READY',
        NOT_READY = 'NOT_READY',
        NOT_SUPPORTED = 'NOT_SUPPORTED',
    }
    export enum create_update_delete_customer_address {
        READY = 'READY',
        NOT_READY = 'NOT_READY',
        NOT_SUPPORTED = 'NOT_SUPPORTED',
    }
    export enum get_customer_contacts {
        READY = 'READY',
        NOT_READY = 'NOT_READY',
        NOT_SUPPORTED = 'NOT_SUPPORTED',
    }
    export enum create_update_delete_customer_contacts {
        READY = 'READY',
        NOT_READY = 'NOT_READY',
        NOT_SUPPORTED = 'NOT_SUPPORTED',
    }
    export enum create_customer_contact {
        READY = 'READY',
        NOT_READY = 'NOT_READY',
        NOT_SUPPORTED = 'NOT_SUPPORTED',
    }
    export enum find_available_sales_documents {
        READY = 'READY',
        NOT_READY = 'NOT_READY',
        NOT_SUPPORTED = 'NOT_SUPPORTED',
    }
    export enum find_sales_document {
        READY = 'READY',
        NOT_READY = 'NOT_READY',
        NOT_SUPPORTED = 'NOT_SUPPORTED',
    }
}

